module.exports = __webpack_public_path__ + "img/badge_salute_semplice.f6c2a645.png";